<template>
  <div>
    <div>
      <div>
        <h2>监视坐标图(经气象调整后)</h2>
      </div>

      <div style="text-align: left">
        <el-collapse accordion>
          <el-collapse-item>
            <template slot="title">
              <span style="color: #f56c6c"
                >什么是气象调整方法？<i class="header-icon el-icon-info"></i
              ></span>
            </template>
            <div>
              基于2011年3月到2019年2月累积八年的小时气象数据，对“2+66”城市分别构造基准气象条件，在此基准气象条件下计算各季节污染物的浓度，通过控制气象条件，捕捉潜在排放量的变化。具体来说，我们采用核估计方法，对各年份和季度的污染与气象数据建立调整模型，将该模型作用于八年基准气象的经验分布函数，计算调整均值。
            </div>
          </el-collapse-item>
        </el-collapse>
        <el-collapse accordion>
          <el-collapse-item>
            <template slot="title">
              <span style="color: #f56c6c"
                >污染物浓度超标标准<i class="header-icon el-icon-info"></i
              ></span>
            </template>
            <div>
              <el-table :data="tableData" border style="width: 100%">
                <el-table-column prop="level" label="超标标准">
                </el-table-column>
                <el-table-column prop="pm2_5">
                  <template slot="header" slot-scope="scope">
                    PM2.5(ug/m<sup>3</sup>)
                  </template>
                </el-table-column>
                <el-table-column prop="PM10" label="PM10">
                  <template slot="header" slot-scope="scope">
                    PM10(ug/m<sup>3</sup>)
                  </template>
                </el-table-column>
                <el-table-column prop="pm10_2_5" label="PM10-2.5">
                  <template slot="header" slot-scope="scope">
                    PM10-2.5(ug/m<sup>3</sup>)
                  </template>
                </el-table-column>
                <el-table-column prop="SO2" label="SO2">
                  <template slot="header" slot-scope="scope">
                    SO2(ug/m<sup>3</sup>)
                  </template>
                </el-table-column>
                <el-table-column prop="CO" label="CO">
                  <template slot="header" slot-scope="scope">
                    CO(mg/m<sup>3</sup>)
                  </template>
                </el-table-column>
                <el-table-column prop="NO2" label="NO2">
                  <template slot="header" slot-scope="scope">
                    NO2(ug/m<sup>3</sup>)
                  </template>
                </el-table-column>
                <el-table-column prop="O3" label="O3">
                  <template slot="header" slot-scope="scope">
                    O3(ug/m<sup>3</sup>)
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>

      <el-form class="textAlignLeft">
        <el-form-item label="评估污染物" class="marginZero">
          <el-radio-group v-model="assessMonitorIndex" @change="pullChange">
            <el-radio label="1">PM2.5-(PM10-2.5)</el-radio>
            <el-radio label="2">SO2-CO</el-radio>
            <el-radio label="3">NO2-O3</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="评估年份">
          <!-- <el-date-picker
            v-model="assessYear"
            type="year"
            placeholder="选择评估年份"
            :picker-options="pickerOptions"
            @change="assessYearChange"
            size="mini"
          ></el-date-picker> -->
          <el-select
            size="mini"
            v-model="assessYear"
            placeholder="请选择"
            @change="assessYearChange"
          >
            <el-option
              v-for="item in Years"
              :key="item"
              :label="item + '年'"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>

    <!-- 图像下载 -->
    <div>
      <el-row type="flex" justify="end">
        <el-button type="success" icon="el-icon-download" @click="downloadImage"
          >图像下载</el-button
        >
      </el-row>
    </div>

    <div class="content-body" id="area-monitor-chart-canvas">
      <div
        class="area-monitor-chart"
        id="area-monitor-chart"
        :style="{ height: eleheight + 'px' }"
      ></div>
    </div>
  </div>
</template>

<style scoped>
.area-monitor {
  padding: 0 20px;
}

.el-row {
  margin-bottom: 15px;
}

/* .el-button {
  border-width: 0px;
  color: black;
  padding: 0 10px;
  margin: 0;
  background: transparent;
} */
.el-divider {
  margin: 0;
  margin-bottom: 10px;
}
</style>

<script>
import { getPullStand, getMonitorPulls } from "@/assets/js/my-utils.js";

import { GenerateMapImgFromDom } from "@/assets/js/utils-map.js";

export default {
  name: "Platform",
  data() {
    return {
      chart: [],
      tableData: [
        {
          level: "超标界限",
          pm2_5: "60",
          PM10: "110",
          pm10_2_5: "50",
          SO2: "25",
          CO: "1.25",
          NO2: "45",
          O3: "120",
        },
      ],
      cityname: ["北京"],
      eleheight: 600,
      assessYear: "2023",
      Years: [
        "2023",
        "2022",
        "2021",
        "2020",
        "2019",
        "2018",
        "2017",
        "2016",
        "2015",
        "2014",
        "2013",
      ],
      assessMonitorIndex: "1",
      pickerOptions: {
        disabledDate(time) {
          return time.getFullYear() > 2019 || time.getFullYear() < 2013;
        },
      },
    };
  },
  computed: {},
  methods: {
    downloadImage() {
      let imageDom = document.getElementById("area-monitor-chart-canvas");

      let pull1 = "";
      let pull2 = "";
      [pull1, pull2] = getMonitorPulls(this.assessMonitorIndex);

      let title = this.assessYear + "年" + pull1 + "和" + pull2 + "监视坐标图";

      GenerateMapImgFromDom(imageDom, title + ".png");
    },

    assessYearChange() {
      // this.assessYear = this.assessYear.getFullYear() + "";
      this.updateCharts();
    },
    pullChange() {
      this.drawAreaMonitorChart(
        this.chart[0],
        this.pulldata,
        this.assessYear,
        this.assessMonitorIndex
      );
    },

    getMonitorData() {
      const that = this;
      let url = "/AQAssess/getAreaMonitor/" + this.assessYear;
        
      this.$axios
        // .post("/AQAssess/getData.php", {
        //   database: "area_monitor",
        //   year: that.assessYear,
        // })
        
        .get(url)
        .then((res) => {
          that.pulldata = [];
          res.data.forEach((element) => {
            that.assesscity.forEach((ele_city) => {
              if (ele_city[1] == element[0]) {
                that.pulldata.push(element);
              }
            });
          });

          that.drawAreaMonitorChart(
            that.chart[0],
            that.pulldata,
            that.assessYear,
            that.assessMonitorIndex
          );
        });
    },

    updateCharts() {
      this.chart.forEach((element) => {
        element.showLoading();
      });

      this.getMonitorData();
    },

    drawAreaMonitorChart(chart, data, time, monitorIndex) {
      let pull1 = "";
      let pull2 = "";
      [pull1, pull2] = getMonitorPulls(monitorIndex);

      let st1 = getPullStand(pull1);
      let st2 = getPullStand(pull2);

      let formatterData = this.monitorChartDataFormatter(data, monitorIndex);

      let formatter_00 = formatterData.formatter_00;
      let formatter_10 = formatterData.formatter_10;
      let formatter_01 = formatterData.formatter_01;
      let formatter_11 = formatterData.formatter_11;

      let title = time + "年" + pull1 + "和" + pull2 + "监视坐标图";
      let [
        pull1AxisMin,
        pull1AxisMax,
        pull1extLine,
        pull1areaMin,
        pull1areaMax,
      ] = [...this.setAxisRange(pull1, formatterData, 1)];
      let [
        pull2AxisMin,
        pull2AxisMax,
        pull2extLine,
        pull2areaMin,
        pull2areaMax,
      ] = [...this.setAxisRange(pull2, formatterData, 2)];

      let markAreaSeries = function (name, data, color, p1x, p1y, p2x, p2y) {
        this.type = "scatter";
        this.name = name;
        this.symbolSize = 10;
        this.label = {
          show: true,
          position: "top",
          formatter: function (params) {
            return params.data.name;
          },
        };
        this.data = data;
        this.color = color;

        this.markArea = {
          silent: true,
          itemStyle: {
            // normal: {
            //   color: color,
            //   borderWidth: 1,
            //   borderType: "dashed",
            // },

            normal: {
              color: "transparent",
              borderWidth: 1,
              borderType: "dashed",
            },
          },
          label: {
            show: true,
            color: "#969696",
            formatter: function (data) {
              return name;
            },
            fontSize: 24,
            position: "inside",
          },
          data: [
            [
              {
                coord: [p1x, p1y],
              },
              {
                coord: [p2x, p2y],
              },
            ],
          ],
        };
        this.markLine = {
          silent: true,
          lineStyle: {
            normal: {
              type: "solid",
            },
          },
          data: [{ yAxis: pull2extLine }, { xAxis: pull1extLine }],
        };
      };

      let lbSerie = new markAreaSeries(
        pull1 + "和" + pull2 + "均不超标",
        formatter_00,
        "#00E400",
        pull1areaMin,
        pull2areaMin,
        pull1extLine,
        pull2extLine
      );

      let ltSerie = new markAreaSeries(
        pull2 + "超标",
        formatter_01,

        "#E6A23C",
        pull1areaMin,
        pull2extLine,
        pull1extLine,
        pull2areaMax
      );

      let rbSerie = new markAreaSeries(
        pull1 + "超标",
        formatter_10,
        "#409EFF",
        pull1extLine,
        pull2areaMin,
        pull1areaMax,
        pull2extLine
      );

      let rtSerie = new markAreaSeries(
        pull1 + "和" + pull2 + "均超标",
        formatter_11,
        "#7E0023",
        pull1extLine,
        pull2extLine,
        pull1areaMax,
        pull2areaMax
      );

      let option = {
        // backgroundColor: waterMark(document),
        title: [
          {
            text: title,
            x: "center",
          },
        ],
        legend: { top: 25, right: "center" },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            show: true,
            type: "cross", //十字准星指示器。其实是种简写，表示启用两个正交的轴的 axisPointer
            lineStyle: {
              type: "dashed",
              width: 1,
            },
          },
          formatter: function (params) {
            console.log(params);
            let text = "";
            params.forEach((param) => {
              text +=
                param.data.name +
                "<br>" +
                param.marker +
                pull1 +
                ": " +
                parseFloat(param.value[0]).toFixed(2) +
                st1 +
                "<br>" +
                param.marker +
                pull2 +
                ": " +
                parseFloat(param.value[1]).toFixed(2) +
                st2;
            });

            return text;
          },
        },
        grid: {
          left: 50,
          right: 65,
        },

        xAxis: [
          {
            type: "value",
            name: pull1,
            nameLocation: "center",
            nameGap: 25, //坐标轴名称与轴线之间的距离
            scale: true,
            axisLabel: {
              formatter: "{value}",
            },
            // splitLine: {
            //   show: false,
            // },
            min: pull1AxisMin,
            max: pull1AxisMax,
          },
        ],
        yAxis: [
          {
            type: "value",
            name: pull2,
            nameLocation: "center",
            nameGap: 25, //坐标轴名称与轴线之间的距离
            scale: true,
            axisLabel: {
              formatter: "{value}",
            },
            // splitLine: {
            //   show: false,
            // },
            min: pull2AxisMin,
            max: pull2AxisMax,
          },
        ],

        series: [lbSerie, ltSerie, rbSerie, rtSerie],
      };
      chart.setOption(option);
      chart.resize();
      chart.hideLoading();
    },

    // 根据不同污染物设定标准线
    setAxisRange(pull1, data, index) {
      let allCityData = [];
      data.formatter_00.forEach((element) => {
        allCityData.push(element.value[index - 1]);
      });
      data.formatter_10.forEach((element) => {
        allCityData.push(element.value[index - 1]);
      });
      data.formatter_01.forEach((element) => {
        allCityData.push(element.value[index - 1]);
      });
      data.formatter_11.forEach((element) => {
        allCityData.push(element.value[index - 1]);
      });

      let pull1AxisMin = Math.min(...allCityData);
      let pull1AxisMax = Math.max(...allCityData);

      let dataMin = Math.min(...allCityData);
      let dataMax = Math.max(...allCityData);

      if (pull1 == "PM2.5") {
        pull1AxisMin = 20;
        pull1AxisMax = 75;
      } else if (pull1 == "PM10-2.5") {
        pull1AxisMin = 20;
        pull1AxisMax = 75;
      } else if (pull1 == "SO2") {
        pull1AxisMin = 0;
        pull1AxisMax = 35;
      } else if (pull1 == "CO") {
        pull1AxisMin = 0.4;
        pull1AxisMax = 2;
      } else if (pull1 == "NO2") {
        pull1AxisMin = 10;
        pull1AxisMax = 60;
      } else if (pull1 == "O3") {
        pull1AxisMin = 90;
        pull1AxisMax = 180;
      }

      pull1AxisMin = pull1AxisMin < dataMin ? pull1AxisMin : dataMin;
      pull1AxisMax = pull1AxisMax > dataMax ? pull1AxisMax : dataMax;

      let areaMin = pull1AxisMin;
      let areaMax = pull1AxisMax;

      let extLine = 60;

      if (pull1 == "PM10-2.5") {
        extLine = 50;
      } else if (pull1 == "SO2") {
        extLine = 25;
      } else if (pull1 == "CO") {
        extLine = 1.25;
      } else if (pull1 == "NO2") {
        extLine = 45;
      } else if (pull1 == "O3") {
        extLine = 120;
      }

      return [pull1AxisMin, pull1AxisMax, extLine, areaMin, areaMax];
    },

    // 转化数据格式
    monitorChartDataFormatter(data, monitorIndex) {
      let formatter_00 = []; //均不超标
      let formatter_10 = []; //前者超标
      let formatter_01 = [];
      let formatter_11 = [];

      data.forEach((element) => {
        if (monitorIndex == 1) {
          // PM2.5 PM10-2.5
          if (
            parseFloat(element[1]) > 60 &&
            parseFloat(element[2] - element[1]) > 50
          ) {
            formatter_11.push({
              name: element[0],
              value: [element[1], element[2] - element[1]],
            });
          } else if (parseFloat(element[1]) > 60) {
            formatter_10.push({
              name: element[0],
              value: [element[1], element[2] - element[1]],
            });
          } else if (parseFloat(element[2] - element[1]) > 50) {
            formatter_01.push({
              name: element[0],
              value: [element[1], element[2] - element[1]],
            });
          } else {
            formatter_00.push({
              name: element[0],
              value: [element[1], element[2] - element[1]],
            });
          }
        } else if (monitorIndex == 2) {
          // SO2 CO

          if (parseFloat(element[3]) > 25 && parseFloat(element[4]) > 1.25) {
            formatter_11.push({
              name: element[0],
              value: [element[3], element[4]],
            });
          } else if (parseFloat(element[3]) > 25) {
            formatter_10.push({
              name: element[0],
              value: [element[3], element[4]],
            });
          } else if (parseFloat(element[4]) > 1.25) {
            formatter_01.push({
              name: element[0],
              value: [element[3], element[4]],
            });
          } else {
            formatter_00.push({
              name: element[0],
              value: [element[3], element[4]],
            });
          }
        } else {
          // NO2 O3
          if (parseFloat(element[5]) > 45 && parseFloat(element[6]) > 120) {
            formatter_11.push({
              name: element[0],
              value: [element[5], element[6]],
            });
          } else if (parseFloat(element[5]) > 45) {
            formatter_10.push({
              name: element[0],
              value: [element[5], element[6]],
            });
          } else if (parseFloat(element[6]) > 120) {
            formatter_01.push({
              name: element[0],
              value: [element[5], element[6]],
            });
          } else {
            formatter_00.push({
              name: element[0],
              value: [element[5], element[6]],
            });
          }
        }
      });

      return {
        formatter_00: formatter_00,
        formatter_10: formatter_10,
        formatter_01: formatter_01,
        formatter_11: formatter_11,
      };
    },
  },
  created() {},
  mounted() {
    if (this.show) {
      this.chart.push(
        this.$echarts.init(document.getElementById("area-monitor-chart"))
      );

      this.updateCharts();
    }

    const that = this;
    window.addEventListener("resize", () => {
      that.chart.forEach((element) => {
        element.resize();
      });
    });
  },
  props: {
    assesscity: {
      type: Array,
      // 对象或数组默认值必须从一个工厂函数获取
      default: function () {
        return [
          ["直辖市", "北京"],
          ["直辖市", "天津"],
        ];
      },
    },

    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    assesscity: function (newAssesscity, oldAssesscity) {
      this.assesscity = newAssesscity;
      if (this.show) {
        this.updateCharts();
      }
    },

    show: function (newShow, oldShow) {
      this.show = newShow;
      if (this.show) {
        this.chart.forEach((element) => {
          element.dispose();
        });
        this.chart = [];

        this.chart.push(
          this.$echarts.init(document.getElementById("area-monitor-chart"))
        );

        this.updateCharts();
      } else {
        this.chart.forEach((element) => {
          element.clear();
        });
      }
    },
  },
};
</script>



